import React from 'react';
import { TeacherImageGallery } from '@edx/graphql/generated';
import { GalleryTile } from './components/gallery-tile';

type Props = {
  images: TeacherImageGallery;
};

export const TeacherGallery: React.FC<Props> = ({ images }) => (
  <section>
    <ul className="flex flex-col sm:flex-row sm:h-60vh">
      <li className="w-full sm:w-2/3 flex">
        <GalleryTile
          image={images.first}
          containerClassName="w-2/5 sm:w-1/3 hover:w-1/2 transition-all duration-200 ease relative overflow-hidden object-cover"
          imageClassName="w-full h-full object-cover filter-grayscale hover:filter-none transition-all duration-200"
        />
        <GalleryTile
          image={images.second}
          containerClassName="w-1/2 flex-auto h-full overflow-hidden relative overflow-hidden"
          imageClassName="object-cover object-right lg:object-center w-full h-full"
        />
      </li>
      <li className="w-full sm:w-1/3 flex-grow flex flex-row sm:flex-col">
        <GalleryTile
          image={images.third}
          containerClassName="group flex-auto w-1/2 hover:w-3/4 sm:hover:w-full sm:w-full sm:h-1/2 sm:hover:h-4/5 transition-all duration-200 ease relative overflow-hidden object-cover"
          imageClassName="w-full h-full object-cover object-center filter-grayscale hover:filter-none transition-all duration-200 transition-all duration-200 ease transform group-hover:scale-110"
        />

        <GalleryTile
          image={images.fourth}
          containerClassName="group flex-auto w-1/2 hover:w-3/4 sm:hover:w-full sm:w-full sm:h-1/2 sm:hover:h-4/5 Ωtransition-all duration-200 ease relative overflow-hidden object-cover"
          imageClassName="w-full h-full object-cover object-center filter-grayscale hover:filter-none transition-all duration-200 transition-all duration-200 ease transform group-hover:scale-110"
        />
      </li>
    </ul>
  </section>
);
